import React from "react";
import { MutatingDots } from "react-loader-spinner";

const LoadingSpinner = () => (
  <div className="flex justify-center items-center w-full h-full bg-gradient-to-br from-opacity-40 to-opacity-60 backdrop-blur-sm absolute top-0 left-0 z-20">
    <MutatingDots
      visible={true}
      height="100"
      width="100"
      color="#4fa94d"
      secondaryColor="#4fa94d"
      radius="12.5"
      ariaLabel="mutating-dots-loading"
    />
  </div>
);

export default LoadingSpinner; 